module.exports = __webpack_public_path__ + "static/media/product_sample_11.1d66bf6a.jpg";